<app-link
    [appRouterLink]="subCollectionLink"
    class="card gtm-premium-collection-overlay-card selenium-premium-collection-overlay-card"
    [attr.data-gtmlabel]="premiumSectionItem.title"
    [attr.data-gtmsectionname]="sectionName"
>
    <img [src]="imageURL" [alt]="imageAlt" />
    <div class="title">
        <h4 [ngClass]="{ 'line-clamp': !windowSize.isTablet }">{{ premiumSectionItem.title }}</h4>
    </div>
</app-link>
